import React from 'react';
import { bemComponent } from '../../../../utils/app';

interface Props {
    isSidebarHidden?: boolean;
    isAnimatable?: boolean;
    children?: React.ReactNode;
}

export class Frame extends React.Component<Props> {
    render() {
        const data: { [key: string]: boolean } = {};

        if (this.props.isSidebarHidden) {
            data['data-sidebar-hidden'] = true;
        }

        if (this.props.isAnimatable) {
            data['data-animatable'] = true;
        }

        return (
            <div className="fullscreen-frame" {...data}>
                {this.props.children}
            </div>
        );
    }
}

export const Main = bemComponent('fullscreen-frame__main', 'Main');
export const Sidebar = bemComponent('fullscreen-frame__sidebar', 'Sidebar');
